import React, { useState } from 'react'
import ActivityCard from '../Advisor/components/AllClientActivity/ActivityCard'
import ActivityDetailModal from '../../AdvisorPortal/Dashboard/components/AllClientActivity/ActivityDetailModal'

const Activity = ({ item, query }) => {
    const [showDetailModal, setShowDetailModal] = useState(false);

    const handleShowDetails = (activity) => {
        setShowDetailModal(true);
    };

    const handleCloseModal = () => {
        setShowDetailModal(false);
    };

    return (
        <>
            <ActivityCard
                item={item}
                onShowDetails={handleShowDetails}
                query={query}
            />

            <ActivityDetailModal
                activity={item}
                open={showDetailModal}
                onClose={handleCloseModal}
                query={query}
            />
        </>
    )
}

export default Activity